import {normalizeGeometry} from '../geometryNormalizer'
import {EditorConfig} from '../../../constants/editorConfig'
import {selectNode, addToSelection, updateNode} from '../../../editorActions'

const InteractionMode = EditorConfig.INTERACTION_MODES

/**
 * @param {object} layersOptional - Optional { mainLayer, dragLayer } for drag layer optimization
 */
export function bindNodeInput(node, editor, interaction, layersOptional, onStartTextEditing, runtime) {
    const nodeId = node.id()
    const mainLayer = layersOptional?.mainLayer
    const dragLayer = layersOptional?.dragLayer
    const isTextEditing = () => runtime?.getUiState?.().textEditing != null

    /** @param {import('konva').KonvaEventObject<PointerEvent>} e */
    function onPointerDown(e) {
        e.cancelBubble = true

        if (isTextEditing()) {
            const session = runtime.getUiState().textEditing
            if (session.nodeId !== nodeId) {
                runtime.commitTextEditing()
                editor.dispatch(selectNode(nodeId, false))
            }
            return
        }

        const isMulti = e.evt?.ctrlKey || e.evt?.metaKey

        editor.dispatch(isMulti ? addToSelection(nodeId) : selectNode(nodeId, false))
    }

    function onDblClick(e) {
        if (!onStartTextEditing) return
        const model = editor.getState().nodes.get(nodeId)
        if (model?.type !== 'text') return
        e.cancelBubble = true
        onStartTextEditing(nodeId)
    }

    let rafScheduled = false

    function onDragStart() {
        if (isTextEditing()) return
        if (interaction.is(InteractionMode.PAN)) return
        interaction.setMode(InteractionMode.DRAG_NODE)
        if (dragLayer) {
            node.moveTo(dragLayer)
        }
    }

    function onDragMove() {
        if (!interaction.is(InteractionMode.DRAG_NODE)) return
        if (rafScheduled) return
        rafScheduled = true
        requestAnimationFrame(() => {
            rafScheduled = false
            editor.dispatch(updateNode(nodeId, {geometry: normalizeGeometry(node)}, {recordHistory: false}))
        })
    }

    function onDragEnd() {
        if (mainLayer) {
            node.moveTo(mainLayer)
        }
        editor.dispatch(updateNode(nodeId, {geometry: normalizeGeometry(node)}, {recordHistory: true}))
        interaction.reset()
    }

    node.on('pointerdown', onPointerDown)
    node.on('dblclick dbltap', onDblClick)
    node.on('dragstart', onDragStart)
    node.on('dragmove', onDragMove)
    node.on('dragend transformend', onDragEnd)

    return function unbind() {
        node.off('pointerdown', onPointerDown)
        node.off('dblclick dbltap', onDblClick)
        node.off('dragstart', onDragStart)
        node.off('dragmove', onDragMove)
        node.off('dragend', onDragEnd)
        node.off('transformend', onDragEnd)
    }
}
